import {
  Form,
  FormBuilder,
  PageLoader,
  useApiAction,
} from "@redriver/cinnamon";
import { Heading } from "components/containers";
import React, { Fragment, useState } from "react";
import { setupPassword, verifyResetToken } from "./actions";
import { Button, Message } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { SystemRoutes } from "constants/routes";

const ResetPassword = ({ token }) => {
  const [verifyResult] = useApiAction(verifyResetToken, {
    lazy: false,
    actionParams: token,
  });

  const isVerifiedToken =
    !verifyResult.busy && verifyResult.success && !!verifyResult.response;

  return (
    <div>
      <Heading>Set Password</Heading>

      {verifyResult.busy ? (
        <PageLoader />
      ) : isVerifiedToken ? (
        <SetPasswordForm token={token} />
      ) : (
        <Message color="red">
          <p>
            Invalid password reset token. Please start the password reset
            process again
          </p>
        </Message>
      )}

      <div style={{ marginTop: "1em" }}>
        <Link to={SystemRoutes.Login}>Back to login</Link>
      </div>
    </div>
  );
};

const SetPasswordForm = ({ token }) => {
  const [hasReset, setHasReset] = useState(false);
  return (
    <div>
      <FormBuilder
        submitAction={setupPassword}
        submitParams={token}
        onSubmitted={() => setHasReset(true)}
        renderForm={(formProps, state, events) => (
          <Form {...formProps}>
            {hasReset ? (
              <p>You have successfully updated your password</p>
            ) : (
              <Fragment>
                <Form.Password
                  field="newPassword"
                  label="New Password"
                  minLength={6}
                  required
                />
                <Form.Password
                  field="confirmPassword"
                  label="Confirm Password"
                  required
                  confirmField="newPassword"
                />
                <Button
                  className="rounded-button"
                  primary
                  onClick={events.onSubmit}
                  loading={state.submitting}
                >
                  Set Password
                </Button>
              </Fragment>
            )}
          </Form>
        )}
      />
    </div>
  );
};

export default ResetPassword;
